import Vue from 'vue'
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  alert(msg, type) {
    const Toast = Swal.mixin({
      toast: true,
      position: "bottom-end",
      showConfirmButton: false,
      timer: 9000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });
    Toast.fire({
      icon: (type ? type : null),
      title: msg,
    });
  }

}
